import { render, staticRenderFns } from "./ManageRolesModal.vue?vue&type=template&id=77904ea6&scoped=true"
import script from "./ManageRolesModal.vue?vue&type=script&lang=js"
export * from "./ManageRolesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77904ea6",
  null
  
)

export default component.exports